import { Controller, useFormContext } from "react-hook-form";
import { Remove2faFormValues } from "../../types";
import {
  Label,
  Stack,
  Text,
  TextField,
} from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";

export interface EnterCredentialsFieldsetProps {}

export const EnterCredentialsFieldset = ({}: EnterCredentialsFieldsetProps) => {
  const formContext = useFormContext<Remove2faFormValues>();

  const { control, register, formState } = formContext;
  const { errors, isValid, isDirty, isSubmitting } = formState;
  const isDisabled = !isValid || !isDirty || isSubmitting;

  return (
    <View>
      <Stack vertical>
        <Text>Confirm your password</Text>
        <Text>A code will be sent to your chosen MFA strategy.</Text>

        <View>
          <Label required label="Password"></Label>
          <Controller
            name="data.password"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                value={value ?? ""}
                secureTextEntry
                onChangeText={onChange}
                validationMessage={error ? error.message : undefined}
                placeholder="Enter your password"
              />
            )}
          />
        </View>
      </Stack>
    </View>
  );
};
